import firebase from 'firebase/app';
import "firebase/firestore";
import "firebase/storage";


// Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  var firebaseConfig = {
    apiKey: "AIzaSyCjCX0dHCRUFGFXTAh1lqB1oobKIujJVD0",
    authDomain: "uicaster.firebaseapp.com",
    projectId: "uicaster",
    storageBucket: "uicaster.appspot.com",
    messagingSenderId: "531081646580",
    appId: "1:531081646580:web:a88f6bac18e6b5c8f9a9a1",
    measurementId: "G-JGME28EKS3"
  };
  // Initialize Firebase
  const firebaseApp = firebase.initializeApp(firebaseConfig);



  export default firebaseApp.firestore();
